import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    FiGrid, FiGlobe, FiMenu, FiFileText, FiBookOpen,
    FiUsers, FiMail, FiBriefcase, FiFolder, FiStar,
    FiAward, FiShield, FiInfo, FiLayers, FiMessageSquare,
    FiZap, FiImage, FiChevronLeft, FiChevronRight, FiChevronDown, FiChevronUp
} from 'react-icons/fi';
import './Sidebar.scss';

export const menuGroups = [
    {
        group: 'Chính',
        items: [
            { path: '/admin/dashboard', name: 'Dashboard', icon: <FiGrid />, end: true },
            { path: '/admin/users', name: 'Quản lý Người dùng', icon: <FiUsers />, adminOnly: true },
            { path: '/admin/languages', name: 'Ngôn ngữ', icon: <FiGlobe /> },
            { path: '/admin/nav-menus', name: 'Menu chính', icon: <FiMenu /> },
        ]
    },
    {
        group: 'Nội dung',
        items: [
            { path: '/admin/home-banners', name: 'Banner Trang chủ', icon: <FiImage /> },
            { path: '/admin/news-categories', name: 'Danh mục tin tức', icon: <FiFolder /> },
            { path: '/admin/news', name: 'Tin tức', icon: <FiFileText /> },
            { path: '/admin/custom-pages', name: 'Quản lý Trang', icon: <FiFileText /> },
            { path: '/admin/shareholder-documents', name: 'Tài liệu cổ đông', icon: <FiBookOpen /> },
            { path: '/admin/section-content-cards', name: 'Card nội dung', icon: <FiLayers /> },
            { path: '/admin/consultings', name: 'Tư vấn', icon: <FiBookOpen /> },
            { path: '/admin/business-licenses', name: 'Giấy phép kinh doanh', icon: <FiShield /> },
        ]
    },
    {
        group: 'Nhân sự',
        items: [
            { path: '/admin/recruitments', name: 'Tuyển dụng', icon: <FiBriefcase /> },
            { path: '/admin/recruitment-departments', name: 'Phòng ban tuyển dụng', icon: <FiFolder /> },
            { path: '/admin/recruitment-applications', name: 'Quản lý Hồ sơ CV', icon: <FiFileText /> },
            { path: '/admin/contacts', name: 'Liên hệ', icon: <FiMail /> },
            { path: '/admin/customer-categories', name: 'Loại đối tác / Khách hàng', icon: <FiFolder /> },
            { path: '/admin/customers', name: 'Khách hàng', icon: <FiUsers /> },
            { path: '/admin/leader-categories', name: 'Danh mục lãnh đạo', icon: <FiAward /> },
            { path: '/admin/leaders', name: 'Lãnh đạo', icon: <FiStar /> },
            { path: '/admin/leader-information-items', name: 'Thông tin lãnh đạo', icon: <FiFileText /> },
            { path: '/admin/organization-charts', name: 'Sơ đồ tổ chức', icon: <FiLayers /> },
        ]
    },
    {
        group: 'Dự án',
        items: [
            { path: '/admin/ecosystem-groups', name: 'Hệ sinh thái', icon: <FiLayers /> },
            { path: '/admin/ecosystem-services', name: 'Dịch vụ Hệ sinh thái', icon: <FiGrid /> },
            { path: '/admin/typical-projects', name: 'Dự án tiêu biểu', icon: <FiZap /> },
            { path: '/admin/project-information-types', name: 'Loại thông tin dự án', icon: <FiInfo /> },
            { path: '/admin/typical-project-information-items', name: 'Thông tin dự án', icon: <FiLayers /> },
            { path: '/admin/projects-in-progress', name: 'Dự án đang triển khai', icon: <FiFileText /> },
            { path: '/admin/projects-in-progress-information-items', name: 'Thông tin dự án đang triển khai', icon: <FiLayers /> },
        ]
    },
    {
        group: 'Giới thiệu',
        items: [
            { path: '/admin/introduce-menus', name: 'Menu giới thiệu', icon: <FiInfo /> },
            { path: '/admin/introduce-overviews', name: 'Tổng quan', icon: <FiInfo /> },
            { path: '/admin/introduce-capacities', name: 'Năng lực', icon: <FiInfo /> },
            { path: '/admin/introduce-messages', name: 'Thông điệp', icon: <FiMessageSquare /> },
            { path: '/admin/introduce-foundationals', name: 'Giá trị nền tảng', icon: <FiInfo /> },
            { path: '/admin/introduce-visions', name: 'Tầm nhìn', icon: <FiInfo /> },
            { path: '/admin/introduce-orientations', name: 'Định hướng', icon: <FiInfo /> },
            { path: '/admin/business-activity-categories', name: 'Danh mục Lĩnh vực KD', icon: <FiFolder /> },
            { path: '/admin/business-activities', name: 'Lĩnh vực & Giải pháp KD', icon: <FiBriefcase /> },
            { path: '/admin/introduce-cultures', name: 'Văn hóa', icon: <FiInfo /> },
            { path: '/admin/introduce-policies', name: 'Chính sách', icon: <FiInfo /> },
        ]
    },
    {
        group: 'Sản phẩm / Giải pháp',
        items: [
            { path: '/admin/product-solution-groups', name: 'Nhóm SP/GP', icon: <FiLayers /> },
            { path: '/admin/product-solution-categories', name: 'Danh mục SP/GP', icon: <FiFolder /> },
            { path: '/admin/product-solution-contents', name: 'Nội dung SP/GP', icon: <FiFileText /> },
        ]
    },
];

const getUserRole = () => {
    try {
        const user = JSON.parse(localStorage.getItem('adminUser') || '{}');
        return (user.role || user.RoleName || '').toLowerCase();
    } catch {
        return '';
    }
};

const HR_ALLOWED_PATHS = new Set([
    '/admin/recruitments',
    '/admin/recruitment-departments',
    '/admin/recruitment-applications',
]);

const Sidebar = ({ collapsed, onToggle }) => {
    const [collapsedGroups, setCollapsedGroups] = useState({});
    const userRole = getUserRole();
    const isHr = userRole === 'hr';

    const toggleGroup = (group) => {
        setCollapsedGroups(prev => ({ ...prev, [group]: !prev[group] }));
    };

    const filteredMenuGroups = menuGroups.map(group => {
        let items = group.items;
        if (userRole !== 'admin') {
            items = items.filter(item => !item.adminOnly);
        }
        if (isHr) {
            items = items.filter(item => HR_ALLOWED_PATHS.has(item.path));
        }
        return { ...group, items };
    }).filter(group => group.items.length > 0);

    return (
        <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
            <div className="sidebar-header">
                <div className="logo">
                    <div className="logo-icon">
                        <img src={require('../../images/Logo/Logo HSV_Icon.jpg')} alt="HSV Logo" />
                    </div>
                    {!collapsed && (
                        <div className="logo-brand">
                            <span className="logo-text">HSV Admin</span>
                            <span className="logo-sub">{isHr ? 'HR Portal' : 'Management System'}</span>
                        </div>
                    )}
                </div>
                <button className="collapse-btn" onClick={onToggle} aria-label="Toggle Sidebar">
                    {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
                </button>
            </div>
            <nav className="sidebar-nav">
                {filteredMenuGroups.map(({ group, items }) => (
                    <div key={group} className="nav-group">
                        {!collapsed && (
                            <button
                                className="nav-group-label"
                                onClick={() => toggleGroup(group)}
                                type="button"
                            >
                                <span>{group}</span>
                                {collapsedGroups[group] ? <FiChevronDown size={12} /> : <FiChevronUp size={12} />}
                            </button>
                        )}
                        {!collapsedGroups[group] && items.map(item => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                end={item.end}
                                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                            >
                                <span className="nav-icon">{item.icon}</span>
                                {!collapsed && <span className="nav-label">{item.name}</span>}
                            </NavLink>
                        ))}
                    </div>
                ))}
            </nav>
        </aside>
    );
};

export default Sidebar;
